module.exports = __webpack_public_path__ + "img/play-arrow.b4fb5809.svg";